import React from 'react'

const SvgClockArrowFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 2c4.963 0 9 4.037 9 9 0 .41-.028.815-.081 1.21a2.15 2.15 0 00-.564.391l-.006.006-.808.804a2.146 2.146 0 00-2.002-1.41 2.156 2.156 0 00-1.512.6l-.007.006-3.389 3.375a2.143 2.143 0 000 3.037l.861.857A9.02 9.02 0 0111 20c-4.963 0-9-4.037-9-9s4.037-9 9-9zm-.001 4.237c.5 0 .906.406.906.906l.001 3.587h1.951a.907.907 0 010 1.813H11a.906.906 0 01-.906-.906l-.002-4.494c0-.5.406-.906.907-.906zM16.529 13a1.155 1.155 0 00-.81.322l-3.382 3.368a1.143 1.143 0 000 1.62l3.376 3.362.006.006a1.154 1.154 0 001.615-.014 1.144 1.144 0 00.014-1.606L14.779 17.5l2.564-2.552.005-.006A1.143 1.143 0 0016.53 13zm4.33 0a1.154 1.154 0 00-.81.322l-3.383 3.368a1.144 1.144 0 000 1.62l3.376 3.362.006.006a1.154 1.154 0 001.614-.014 1.143 1.143 0 00.014-1.606L19.108 17.5l2.563-2.552.006-.006A1.144 1.144 0 0020.859 13z'
    />
  </svg>
)

export default SvgClockArrowFilled
